<script setup>
import { defineProps, onMounted } from "vue";
import SelectInput from "@/components/Dashboard/Utilities/SelectInput.vue";
import useUtilityDropdownsContainer from "@/scripts/Utilities/UtilityDropdownsContainer.js";

const props = defineProps({ updateFieldObject: Function });
const { form, dropdownConfigs, config, resetForm } =
  useUtilityDropdownsContainer(props);

onMounted(() => resetForm());
</script>

<template>
  <template v-for="(ui, key) in dropdownConfigs" :key="key">
    <SelectInput
      :title="ui.title"
      :options="ui.options"
      :placeholder="
        key === 'timezone'
          ? config.timezone?.value ?? 'Select Timezone'
          : 'Please Select'
      "
      v-model="form[key]"
      :current-value="form[key]"
    />
  </template>
</template>
